<div class="filter-container">
    <div class="filter-close">
        <button class="filter-close-btn" (click)="close()">×</button>
    </div>

    <div class="d-flex justify-content-between align-items-center mb-3">
        <h4 class="mb-0 fw-bolder">
            <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M12.9 7C12.5 5.3 10.9 4 9 4C7.1 4 5.6 5.3 5.1 7H2V9H5.1C5.5 10.7 7.1 12 9 12C10.9 12 12.4 10.7 12.9 9H30V7H12.9ZM9 10C7.9 10 7 9.1 7 8C7 6.9 7.9 6 9 6C10.1 6 11 6.9 11 8C11 9.1 10.1 10 9 10ZM23 12C21.1 12 19.6 13.3 19.1 15H2V17H19.1C19.5 18.7 21.1 20 23 20C24.9 20 26.4 18.7 26.9 17H30V15H26.9C26.5 13.3 24.9 12 23 12ZM23 18C21.9 18 21 17.1 21 16C21 14.9 21.9 14 23 14C24.1 14 25 14.9 25 16C25 17.1 24.1 18 23 18ZM14 20C12.1 20 10.6 21.3 10.1 23H2V25H10.1C10.5 26.7 12.1 28 14 28C15.9 28 17.4 26.7 17.9 25H30V23H17.9C17.5 21.3 15.9 20 14 20ZM14 26C12.9 26 12 25.1 12 24C12 22.9 12.9 22 14 22C15.1 22 16 22.9 16 24C16 25.1 15.1 26 14 26Z" fill="#718998"/>
            </svg>
            Filters
        </h4>
    </div>

    <hr />

    <form [formGroup]="form" (submit)="applyFilter()">
        <!-- Engagement Filter (UNIVAPLAT-2574) — must stay FIRST in the list -->
        <div class="mb-3">
            <small class="text-muted fw-semibold" data-testid="filter-label">Engagement</small>
            <ng-select
                [items]="engagementOptions"
                bindLabel="name"
                bindValue="value"
                [multiple]="true"
                [closeOnSelect]="false"
                placeholder="Select Engagement"
                formControlName="engagement">
            </ng-select>
        </div>

        <hr />

        <!-- Role Filter -->
        <div class="mb-3">
            <small class="text-muted fw-semibold" data-testid="filter-label">Role Filter</small>
            <ng-select
                [items]="roleOptions"
                bindLabel="name"
                bindValue="value"
                [multiple]="true"
                [closeOnSelect]="false"
                placeholder="Customer Type"
                formControlName="role">
            </ng-select>
        </div>

        <hr />

        <!-- Plan Type (License) Filter -->
        <div class="mb-3">
            <small class="text-muted fw-semibold" data-testid="filter-label">Plan Type</small>
            <ng-select
                [items]="licenseOptions"
                bindLabel="name"
                bindValue="value"
                [multiple]="true"
                [closeOnSelect]="false"
                placeholder="Select Plan Type"
                formControlName="license">
            </ng-select>
        </div>

        <hr />

        <!-- Customer Type (Category) Filter -->
        <div class="mb-3">
            <small class="text-muted fw-semibold" data-testid="filter-label">Customer Type</small>
            <ng-select
                [items]="categoryOptions"
                bindLabel="name"
                bindValue="value"
                [multiple]="true"
                [closeOnSelect]="false"
                placeholder="Select Customer Type"
                formControlName="category">
            </ng-select>
        </div>

        <hr />

        <!-- Status Filter -->
        <div class="mb-3">
            <small class="text-muted fw-semibold" data-testid="filter-label">Status</small>
            <ng-select
                [items]="statusOptions"
                bindLabel="name"
                bindValue="value"
                [multiple]="true"
                [closeOnSelect]="false"
                placeholder="Select Status"
                formControlName="status">
            </ng-select>
        </div>

        <hr />

            <div class="mb-3">
                <small class="text-muted fw-semibold" data-testid="filter-label">Care Programme</small>
                <ng-select
                    [items]="careProgrammeOptions"
                    bindLabel="name"
                    bindValue="id"
                    [multiple]="true"
                    [closeOnSelect]="false"
                    placeholder="Select Care Programme"
                    formControlName="careProgramme">
                </ng-select>
            </div>

            <hr />

            <!-- Organisation Filter -->
            <div class="mb-3">
                <small class="text-muted fw-semibold" data-testid="filter-label">Organisation</small>
                <ng-select
                    [items]="organisationOptions"
                    bindLabel="name"
                    bindValue="id"
                    [multiple]="true"
                    [closeOnSelect]="false"
                    placeholder="Select organisations"
                    formControlName="organisation">
                </ng-select>
            </div>

            <hr />

            <!-- Service Filter -->
            <div class="mb-3">
                <small class="text-muted fw-semibold" data-testid="filter-label">Service</small>
                <ng-select
                    [items]="serviceOptions"
                    bindLabel="name"
                    bindValue="id"
                    [multiple]="true"
                    [closeOnSelect]="false"
                    placeholder="Select services"
                    formControlName="service">
                </ng-select>
            </div>

            <hr />

            <!-- Department Filter -->
            <div class="mb-3">
                <small class="text-muted fw-semibold" data-testid="filter-label">Team</small>
                <ng-select
                    [items]="departmentOptions"
                    bindLabel="name"
                    bindValue="id"
                    [multiple]="true"
                    [closeOnSelect]="false"
                    placeholder="Select teams"
                    formControlName="department">
                </ng-select>
            </div>

            <hr />

            <!-- Week Filter -->
        <div class="mb-3">
            <small class="text-muted fw-semibold" data-testid="filter-label">Week</small>
            <ng-select
                [items]="weekOptions"
                bindLabel="name"
                bindValue="value"
                [multiple]="true"
                [closeOnSelect]="false"
                placeholder="Select weeks"
                formControlName="currentWeek">
            </ng-select>
        </div>

        <hr />

        <!-- Include Demo Filter -->
        <div class="mb-3">
            <small class="text-muted fw-semibold" data-testid="filter-label">Include Demo</small>

            <div class="form-check mt-2">
                <input
                    class="form-check-input"
                    type="checkbox"
                    formControlName="includeDemo"
                    id="includeDemo"
                />
                <label class="form-check-label" for="includeDemo">
                    Include Demo
                </label>
            </div>
        </div>

        <hr />

            <!-- Signup Date Range -->
            <div class="mb-3">
                <small class="text-muted fw-semibold" data-testid="filter-label">Sign-up Date Range</small>
                <div class="row mt-2">
                    <div class="col-6">
                        <input type="date" class="form-control form-control-sm" formControlName="signupDateStart" placeholder="Start" />
                    </div>
                    <div class="col-6">
                        <input type="date" class="form-control form-control-sm" formControlName="signupDateEnd" placeholder="End" />
                    </div>
                </div>
            </div>

            <hr />

            <!-- First Login Date Range -->
            <div class="mb-3">
                <small class="text-muted fw-semibold" data-testid="filter-label">First Login Date Range</small>
                <div class="row mt-2">
                    <div class="col-6">
                        <input type="date" class="form-control form-control-sm" formControlName="firstLoginDateStart" placeholder="Start" />
                    </div>
                    <div class="col-6">
                        <input type="date" class="form-control form-control-sm" formControlName="firstLoginDateEnd" placeholder="End" />
                    </div>
                </div>
            </div>

            <hr />

            <!-- Last Login Date Range -->
            <div class="mb-3">
                <small class="text-muted fw-semibold" data-testid="filter-label">Last Login Date Range</small>
                <div class="row mt-2">
                    <div class="col-6">
                        <input type="date" class="form-control form-control-sm" formControlName="lastLoginDateStart" placeholder="Start" />
                    </div>
                    <div class="col-6">
                        <input type="date" class="form-control form-control-sm" formControlName="lastLoginDateEnd" placeholder="End" />
                    </div>
                </div>
            </div>

            <hr />

        <!-- Buttons -->
        <div class="d-grid gap-2 mt-4">
            <button type="button" class="btn btn-outline-secondary rounded-pill fw-bold" (click)="reset()">
                RESET ALL
            </button>
            <button type="submit" class="btn btn-success rounded-pill fw-bold">
                APPLY FILTERS
            </button>
        </div>
    </form>
</div>
